import * as React from "react";
const SvgFiRrPlanetRinged = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-planet-ringed_svg__a)">
      <path
        fill="#062147"
        d="M23.36.639c-1.303-1.304-3.927-.626-7.799 2.017A10 10 0 0 0 11.999 2C6.486 2 2 6.486 2 12c0 1.254.233 2.454.656 3.56C.012 19.434-.667 22.057.64 23.36q.637.638 1.703.638c1.153 0 2.679-.56 4.562-1.675a29 29 0 0 0 1.533-.98A10 10 0 0 0 12 22c5.514 0 10-4.486 10-10a9.9 9.9 0 0 0-.664-3.581c2.168-3.166 3.514-6.29 2.024-7.78m-1.414 1.414c.319.319-.142 1.917-1.665 4.347a10.1 10.1 0 0 0-2.687-2.685c3.02-1.9 4.233-1.782 4.352-1.662M12 4a8.01 8.01 0 0 1 7.048 4.217c-1.236 1.699-2.89 3.667-5.027 5.804-1.944 1.944-3.937 3.669-5.799 5.029A8 8 0 0 1 4.001 12c0-4.41 3.589-8 8-8zM5.886 20.602c-2.689 1.593-3.735 1.44-3.832 1.344-.122-.122-.235-1.337 1.661-4.352a10.1 10.1 0 0 0 2.691 2.69q-.263.166-.52.318M20 12c0 4.41-3.589 8-8 8a8 8 0 0 1-1.527-.147 55 55 0 0 0 4.962-4.418 56 56 0 0 0 4.413-4.99q.15.756.152 1.555"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-planet-ringed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlanetRinged;
